function Error(props) {
  return <div className=""> ERROR PAGEEE</div>;
}

export default Error;
